let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eZCQI"), load("chivm"), load("hTcok")]).then(() => parcelRequire('3u3VR'));